/**
 * @generated SignedSource<<18667f9fe159d5b918288ed710409d9c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type InviteClientByCodeInput = {
  clientMutationId?: string | null | undefined;
  code: string;
  email: string;
};
export type ClientLinkInviteScreenInviteMutation$variables = {
  input: InviteClientByCodeInput;
};
export type ClientLinkInviteScreenInviteMutation$data = {
  readonly inviteClientByCode: {
    readonly invite: {
      readonly id: string;
    };
  } | null | undefined;
};
export type ClientLinkInviteScreenInviteMutation = {
  response: ClientLinkInviteScreenInviteMutation$data;
  variables: ClientLinkInviteScreenInviteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "InviteClientByCodePayload",
    "kind": "LinkedField",
    "name": "inviteClientByCode",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Invite",
        "kind": "LinkedField",
        "name": "invite",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ClientLinkInviteScreenInviteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ClientLinkInviteScreenInviteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "43724e7d94fa73dd2f57972b755b4c0b",
    "id": null,
    "metadata": {},
    "name": "ClientLinkInviteScreenInviteMutation",
    "operationKind": "mutation",
    "text": "mutation ClientLinkInviteScreenInviteMutation(\n  $input: InviteClientByCodeInput!\n) {\n  inviteClientByCode(input: $input) {\n    invite {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "16f71880115157d0bdcf87c665fc5c1b";

export default node;
